<script setup lang="ts">
  import { computed, inject, watch } from 'vue'
  import { testIds } from '@gat-ship/types'
  import { useAgencyContext } from '../composables/useAgency'
  import { agencyModalsKey } from '../components'
  import { Button, ContentRowTwoColumns } from '@gat-ship/vue-components'
  import { useUser } from '@gat-ship/user'

  const user = useUser()

  const props = defineProps<{ id: string }>()

  const agencyProvider = useAgencyContext()
  const agencyModals = inject(agencyModalsKey)

  watch(
    () => props.id,
    async (agencyId) => {
      if (agencyId) {
        agencyProvider?.fetchAgency(agencyId)
      }
    },
    { immediate: true }
  )

  const isDeactivated = computed(
    () => agencyProvider?.agency.value?.isInactive === true
  )

  const agency = computed(() => agencyProvider?.agency.value)
</script>
<template>
  <ContentRowTwoColumns v-if="isDeactivated && agency" title="Activate Agency">
    <template #description> This action will activate immediately. </template>
    <div class="flex grow items-center justify-end">
      <Button
        v-if="
          agency &&
          user.isTenantAdmin.value &&
          agency.canReactivate &&
          agency.isInactive
        "
        variant="outline"
        size="sm"
        class="w-fit"
        :data-testid="testIds.agency.action.reactivateAgency"
        @click="agencyModals?.showReactivateAgencyModal({ agency })"
      >
        Reactivate Agency
      </Button>
    </div>
  </ContentRowTwoColumns>
  <ContentRowTwoColumns
    v-if="!isDeactivated && agency"
    title="Deactivate Agency"
  >
    <template #description>
      This action will remove the agency from the agency structure and all
      future agency operations will be stopped.
    </template>
    <div class="flex grow items-center justify-end">
      <Button
        v-if="agency && user.isTenantAdmin.value && agency.canDeactivate"
        variant="outline"
        size="sm"
        class="w-fit"
        :data-testid="testIds.agency.action.deactivateAgency"
        @click="agencyModals?.showAgencyDeactivateModal({ agency })"
      >
        Deactivate Agency
      </Button>
    </div>
  </ContentRowTwoColumns>
</template>
